<template>
  <div class="product-card">
    <div class="pc-inner">
      <div class="pc-img" @click="imgClicked">
        <div class="inner">
          <img :src="productImg" alt="">
        </div>
        <div class="pc-temp">
          <img :src="productTemperatureImg" v-if="productTemperatureImg !== null" alt="">
        </div>
        <!-- <b-badge variant="light" class="pc-temp">{{ product.temperatureCategory }}</b-badge> -->
      </div>

      <p class="pc-name text-truncate">{{ productName }}</p>

      <div class="d-flex justify-content-center">
        <p class="pc-price"><span v-if="hasSale" class="pc-origin-price">NT {{ product.originPrice }} </span>NT {{ productPrice }}</p>
      </div>

      <button class="add-to-cart-btn" @click="addToCartClicked">
        <!-- <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.4375 21.3125L13.0625 16.5" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
          <path d="M11.6875 6.1875L8.9375 10.3125M21.3125 6.1875L24.0625 10.3125" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
          <path d="M18.5625 21.3125L19.9375 16.5" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
          <path d="M6.1875 13.0625V13.0625C6.99089 13.0625 7.6865 13.6205 7.86078 14.4048L9.61644 22.3052C9.95013 23.8069 10.117 24.5577 10.6654 24.9976C11.2138 25.4375 11.9829 25.4375 13.5212 25.4375H19.4788C21.0171 25.4375 21.7862 25.4375 22.3346 24.9976C22.883 24.5577 23.0499 23.8069 23.3836 22.3052L25.1392 14.4048C25.3135 13.6205 26.0091 13.0625 26.8125 13.0625V13.0625" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
          <path d="M26.8125 13.0625H6.1875C5.42811 13.0625 4.8125 12.4469 4.8125 11.6875C4.8125 10.9281 5.42811 10.3125 6.1875 10.3125H26.8125C27.5719 10.3125 28.1875 10.9281 28.1875 11.6875C28.1875 12.4469 27.5719 13.0625 26.8125 13.0625Z" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
        </svg> -->
        加入至購物車
      </button>
    </div>

    <AddToCartModal v-model="showAddToCartModal" :product="product"></AddToCartModal>
  </div>
</template>

<script>
import AddToCartModal from '../cart/AddToCartModal.vue';
import moment from 'moment';

export default {
  name: 'ProductCard',
  data() {
    return {
      showAddToCartModal: false,

      productTemperatureImgs: [
        require(`@/assets/img/product/t-normal.png`),
        require(`@/assets/img/product/t-cold.png`),
        require(`@/assets/img/product/t-freeze.png`),
      ],
    };
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddToCartModal,
  },
  computed: {
    productImg() {
      if (this.product.imgs.length > 0) {
        return this.product.imgs[0];
      }
      return '';
    },
    productTemperatureImg() {
      const t = this.product.temperatureCategory;
      if (t === '常溫') {
        return this.productTemperatureImgs[0];
      } else if (t === '冷藏') {
        return this.productTemperatureImgs[1];
      } else if (t === '冷凍') {
        return this.productTemperatureImgs[2];
      }
      return null;
    },
    productName() {
      return this.product.name;
    },
    productPrice() {
      if (this.product.earlyPrice > 0 && moment().isSameOrBefore(moment(this.product.earlyDateLimit))) {
        return this.product.earlyPrice;
      }
      if (this.product.sellPrice > 0) {
        return this.product.sellPrice;
      }
      return this.product.originPrice;
    },
    hasSale() {
      if (this.product.earlyPrice > 0 && moment().isSameOrBefore(moment(this.product.earlyDateLimit))) {
        return true;
      }
      if (this.product.sellPrice > 0 && this.product.originPrice > 0 && this.product.originPrice > this.product.sellPrice) {
        return true;
      }
      return false;
    }
  },
  methods: {
    addToCartClicked() {
      this.showAddToCartModal = true;
      // alert('官網建置中!');
    },
    imgClicked() {
      this.$router.push({
        name: 'ProductDetail',
        params: {
          serial: this.product.serial,
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/main.scss';
.product-card {
  .pc-inner {
    position: relative;
    .pc-img {
      position: relative;
      padding-top: 100%;
      margin-bottom: 1rem;
      cursor: pointer;
      .inner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: $color-dark-lightest;
        border-radius: 1.5rem;
        overflow: hidden;
        >img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .pc-temp {
        position: absolute;
        top: 1rem;
        left: 1rem;
        border-radius: 999px;
        background-color: #fff;
        // box-shadow: 0 0 8px 0 #fff;
        >img {
          display: block;
          width: 1.5rem;
        }
      }
    }

    .pc-name {
      color: $color-main-dark;
      font-weight: bold;
      text-align: center;
      margin-bottom: .6rem;
    }

    .pc-price {
      position: relative;
      color: $color-main-dark;
      font-weight: bold;
      text-align: center;
      margin-bottom: .8rem;
      .pc-origin-price {
        color: #f44;
        display: block;
        font-size: .8em;
        position: absolute;
        left: 0;
        transform: translate(-110%, 10%);
        text-decoration: line-through;
      }
    }

    .add-to-cart-btn {
      display: block;
      background-color: #fff;
      border: solid 1px $color-main-dark;
      border-radius: 1rem;
      width: 100%;
      padding: 6px 2px;
      transition: all .2s ease;
      color: $color-main-dark;
      &:hover {
        background-color: $color-main-hilight;
        border-color: transparent;
        color: #fff;
      }
    }
  }
}
</style>